import { render, staticRenderFns } from "./resource-snippet.vue?vue&type=template&id=97b347cc&"
import script from "./resource-snippet.vue?vue&type=script&lang=js&"
export * from "./resource-snippet.vue?vue&type=script&lang=js&"
import style0 from "./resource-snippet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resource-snippet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports